/**
 * usePageContext · 页面接入右栏上下文
 * ------------------------------------------------------------
 * 在页面 setup 顶层调用：
 *
 *   const page = usePageContext({
 *     line: '采购',
 *     node: '采购订单',
 *     summary: '…',
 *     insights: ['…'],
 *     actions: [{ id: 'new', title: '新建采购订单', route: { path: '/procurement' } }],
 *   })
 *   // 页面内切换查看对象时：
 *   page.patch({ object: order.no })
 *
 * 卸载自动注销；同页重复调用以最后一次为准。
 */
import { onBeforeUnmount } from 'vue'
import { usePageContextStore } from './store'
import type { PageContext } from './types'

export function usePageContext(ctx: PageContext) {
  const store = usePageContextStore()
  const token = store.setPage(ctx)
  onBeforeUnmount(() => store.clearPage(token))
  return {
    patch: (p: Partial<PageContext>) => store.patchPage(token, p),
  }
}

export type { PageContext, PageAction } from './types'
